import type { ApiFetchPerfilOficialSectionsPort } from '~/handlers/ports/api-fetch-perfil-oficial-sections.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchPerfilOficialSectionsAdapter
  implements ApiFetchPerfilOficialSectionsPort
{
  async handle(slug: string): Promise<HomeSectionData | null> {
    const response = await fetch(
      `${getApostatudoApiUrl()}/games/sections/${slug}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    if (!response.ok) return null;

    const result: HomeSectionApiResponse = await response.json();

    return result.data;
  }
}
